import { Button, DrawerBody, DrawerFooter, Typography, } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useCommonContext, useExperienceContext, useFulfillmentGroupContext, useOrderContext, } from '../../../hooks/useContexts';
import '../../../styles/drawer.scss';
import { getWindow } from '../../../utils/general';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { TrackBopisOosrAnalytics } from '../../../utils/bopis/bopis-oosr-analytics';
export var EditPickupLocationSurvey = function (_a) {
    var closeDrawer = _a.closeDrawer, isIosMobile = _a.isIosMobile, newStoreNumber = _a.newStoreNumber, isBopisOutOfStock = _a.isBopisOutOfStock;
    var _b = useFulfillmentGroupContext(), fulfillmentGroup = _b.fulfillmentGroup, fulfillmentType = _b.fulfillmentType;
    var _c = useOrderContext(), orderDetailsData = _c.orderDetailsData, orderId = _c.orderId, customerType = _c.customerType;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isMobile = useCommonContext().isMobile;
    useEffect(function () {
        setTimeout(function () {
            var _a, _b, _c, _d;
            if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.QSI) && ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.QSI.API)) {
                (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.QSI.API.load();
                (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.QSI.API.run();
            }
        }, 100);
    });
    useEffect(function () {
        TrackBopisOosrAnalytics('out of stock review your options: edit pickup location survey', 'overlay');
    }, []);
    var renderSurvey = function () {
        var _a, _b, _c, _d, _e;
        return (React.createElement("div", null,
            React.createElement("input", { type: "hidden", id: "orderNumberForEditLocation", value: orderId }),
            React.createElement("input", { type: "hidden", id: "orderOriginForEditLocation", value: orderDetailsData.orderOrigin }),
            React.createElement("input", { type: "hidden", id: "fulfillmentTypeForEditLocation", value: fulfillmentType }),
            React.createElement("input", { type: "hidden", id: "salesDateForEditLocation", value: orderDetailsData.salesDate }),
            React.createElement("input", { type: "hidden", id: "customerTypeForEditLocation", value: customerType }),
            React.createElement("input", { type: "hidden", id: "customerBillingZipForEditLocation", value: orderDetailsData.billingAddress.postalDetails.zipCode }),
            React.createElement("input", { type: "hidden", id: "appXPForEditLocation", value: isConsumerApp ? 'true' : 'false' }),
            React.createElement("input", { type: "hidden", id: "siteXPForEditLocation", value: isMobile ? 'mobile' : 'desktop' }),
            React.createElement("input", { type: "hidden", id: "oldStoreNumberForEditLocation", value: (_b = (_a = fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number }),
            React.createElement("input", { type: "hidden", id: "oldStoreZipForEditLocation", value: (_e = (_d = (_c = fulfillmentGroup.storePickup) === null || _c === void 0 ? void 0 : _c.store) === null || _d === void 0 ? void 0 : _d.address) === null || _e === void 0 ? void 0 : _e.zipCode }),
            React.createElement("input", { type: "hidden", id: "newStoreNumberForEditLocation", value: newStoreNumber }),
            React.createElement("input", { type: "hidden", id: "flowTypeForEditLocation", value: isBopisOutOfStock ? 'outOfStock' : 'customerNeed' }),
            React.createElement("div", { id: "editpulocationXPsurvey", style: {
                    display: 'block',
                } })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null,
            React.createElement(AlertBanner, { status: "success" },
                "Your pickup location has been updated.",
                ' '),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-3" },
                    React.createElement(Typography, null,
                        "We have canceled the items in your original Order # ",
                        orderId,
                        "."),
                    React.createElement(Typography, null, "You\u2019ll get an email confirming the pickup of your items at your new location.")),
                React.createElement(ErrorBoundary, { name: "edit-pickup-survey" }, renderSurvey()))),
        React.createElement(DrawerFooter, { id: "drawer-footer-z-index-fix", className: "sui-bottom-auto sui-p-4" },
            React.createElement("div", { className: classNames('card-fix', {
                    'ios-bottom-fix': isIosMobile,
                }) },
                React.createElement(Button, { variant: "primary", onClick: function () {
                        closeDrawer();
                    } }, "Go Back to Order Details")))));
};
